import { css } from "@emotion/core";
import styled from "@emotion/styled";

export const truncate = css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const resetButton = css`
    border: 0;
    background: transparent;
    padding: 0;
    outline: none;
`;

export const BaseButton = styled.button`
    border: 0;
    background: transparent;
    padding: 0;
    outline: none;
`;
